import { createBlock } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';

export type ImageInteractionProps = InteractionProps & {};

// const contentForColumn = props => (i: number) => {
//   // return [() => createBlock('Text'), () => createBlock('Image')][i];
//   return [() => createBlock('Text'), () => createMediaBlock(props)][i];
// };

const createAssessmentQuestionOption = (props?: {}) => {
  return createBlock('AssessmentQuestionOption', [createBlock('Text')], {
    props: {},
  });
};

const createAssessmentQuestion = (props?: {}) => {
  return createBlock(
    'AssessmentQuestion',
    [
      // createBlock('Image'),
      // createBlock('QuestionCounter'),
      createMediaBlock({}),
      createBlock('Text'),
      createBlock(
        'AssessmentQuestionOptions',
        [0, 1, 2, 3].map(option => createAssessmentQuestionOption())
      ),
      // createEditableBtn({
      //   label: 'Submit',
      // }),
      createContinueBtn({
        label: 'Submit',
        // location: 'next',
        unlocked: true,
      }),
      createBlock('LearnMore', [], {
        props: {
          location: '',
        },
      }),
    ],
    {
      props: {},
    }
  );
};

export const addAssessmentQuestionOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  // console.log(block.type);

  if (block.type === 'AssessmentQuestionOptions') {
    const assessmentOptionBlock = createAssessmentQuestionOption({});

    const contentCardBlockRef = { id: assessmentOptionBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(assessmentOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, contentCardBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeAssessmentQuestionOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'AssessmentQuestionOptions') {
    const assessmentOptionBlock = createAssessmentQuestionOption({});

    const [newBlocks] = flatten(assessmentOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createAssessmentQuestionInteractionBlock = (
  props,
  offset: number = 0
) => {
  return createBlock(
    'Interaction',
    [
      createAssessmentQuestion(),

      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            // createBlock('ContinueButton', 'Continue' as any, {
            //   meta: { subType: 'continue' },
            // }),
            // createContinueBtn(props.style),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        type: 'AssessmentQuestion',
        name: props.name,
        sId: getSId('interaction', offset),
        // includeLearnMore: true,
        style: props.style || {},
      },
      meta: {
        subType: 'AssessmentQuestion',
        // layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
        //   props.columnsReversed ? 'Reversed' : ''
        // }`,
      },
    }
  );
};

export const interactionConfig = {};
